import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import React__default from 'react';
import { hooks } from '@bilibili-maoer/web-utils';
import { CommentConfigContext } from '../context.js';
import { useComment } from '../hooks/use-comment.js';
import useSwitch from '../hooks/use-switch.js';
import { Topic } from '../topic.js';
import { CommentItem } from './comment-item.js';
import CommentPostBox from './comment-post.js';
import { SubComments } from './sub-comments.js';
import { markTestId } from './utils/test-utils.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var postBoxSyncTopic = new Topic();
var POST_OPEN_SOURCE_FROM_OP = 'from_op';
var POST_OPEN_SOURCE_FROM_REPLY = 'from_reply';

function generateReplySourceKey(id) {
  return "".concat(POST_OPEN_SOURCE_FROM_REPLY, "-").concat(id);
}

var CommentBox = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  var _hooks$useUser = hooks.useUser(),
      _hooks$useUser2 = _slicedToArray(_hooks$useUser, 2);
      _hooks$useUser2[0];
      var withLoginRequired = _hooks$useUser2[1].withLoginRequired;

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      postBoxOpenSource = _React$useState2[0],
      setPostBoxOpenSource = _React$useState2[1];

  var _useSwitch = useSwitch(false),
      _useSwitch2 = _slicedToArray(_useSwitch, 2),
      isPostBoxVisible = _useSwitch2[0],
      _useSwitch2$ = _useSwitch2[1],
      setPostBoxVisible = _useSwitch2$.on,
      setPostBoxInVisible = _useSwitch2$.off;

  var _React$useState3 = React__default.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      userReplyTo = _React$useState4[0],
      setUserReplyTo = _React$useState4[1];

  var _useSwitch3 = useSwitch(true),
      _useSwitch4 = _slicedToArray(_useSwitch3, 2),
      isShowMoreBtnVisible = _useSwitch4[0],
      hideShowMoreBtn = _useSwitch4[1].off;

  var _React$useContext = React__default.useContext(CommentConfigContext),
      enableReply = _React$useContext.enableReply;

  var _useComment = useComment(props.data, {
    subCommentMode: 'page'
  }),
      _useComment2 = _slicedToArray(_useComment, 2),
      subComments = _useComment2[0].subComments,
      _useComment2$ = _useComment2[1],
      loadSubCommentsOfPage = _useComment2$.loadSubCommentsOfPage,
      setSubComments = _useComment2$.setSubComments,
      deleteSubComment = _useComment2$.deleteSubComment; // TODO(ayase): 待实现可 createPortal 的 Modal 之后替换该组件的实现


  var openPostBox = function openPostBox(source) {
    var replyTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    setPostBoxOpenSource(source);
    setPostBoxVisible();
    setUserReplyTo(replyTo);
  };

  var closePostBox = function closePostBox() {
    setPostBoxOpenSource(null);
    setPostBoxInVisible();
    setUserReplyTo('');
  };

  var containerRef = React__default.useRef(null);
  React__default.useImperativeHandle(ref, function () {
    return {
      focusComment: function focusComment() {
        if (!containerRef.current) {
          return;
        }

        containerRef.current.scrollIntoView();
        openPostBox(POST_OPEN_SOURCE_FROM_OP);
      },
      focusSubComment: function focusSubComment(subCommentToReply, subCommentsOnThatPage, pagination) {
        if (!containerRef.current) {
          return;
        }

        containerRef.current.scrollIntoView();
        setSubComments(subCommentsOnThatPage, pagination);
        hideShowMoreBtn();
        openPostBox(generateReplySourceKey(subCommentToReply.id), subCommentToReply.username);
      }
    };
  });

  var handlePostBoxSync = function handlePostBoxSync(cmtIdPostBoxWillOpen) {
    var commentId = props.data.id;

    if (commentId !== cmtIdPostBoxWillOpen) {
      closePostBox();
    }
  };

  React__default.useEffect(function () {
    postBoxSyncTopic.register(handlePostBoxSync);
    return function () {
      postBoxSyncTopic.unregister(handlePostBoxSync);
    };
  });
  var handleClickReplyBtnToOP = withLoginRequired(function () {
    postBoxSyncTopic.notify(props.data.id);

    if (postBoxOpenSource !== POST_OPEN_SOURCE_FROM_OP) {
      openPostBox(POST_OPEN_SOURCE_FROM_OP);
      return;
    } // 点击楼主的回复按钮打开的或者未打开


    if (isPostBoxVisible) {
      closePostBox();
    } else {
      openPostBox(POST_OPEN_SOURCE_FROM_OP);
    }
  });
  var handleClickReplyBtnToSubComments = withLoginRequired(function (commentIdToReply, username) {
    postBoxSyncTopic.notify(props.data.id);
    var sourceKey = generateReplySourceKey(commentIdToReply);

    if (postBoxOpenSource !== sourceKey) {
      openPostBox(sourceKey, username);
      return;
    }

    if (isPostBoxVisible) {
      closePostBox();
    } else {
      openPostBox(sourceKey, username);
    }
  });

  var handleReload = function handleReload() {
    var _props$onReloadRequir;

    (_props$onReloadRequir = props.onReloadRequired) === null || _props$onReloadRequir === void 0 ? void 0 : _props$onReloadRequir.call(props);
  };

  var handleShowMore = function handleShowMore() {
    loadSubCommentsOfPage(1);
    hideShowMoreBtn();
  };

  var handlePageChange = function handlePageChange(n) {
    loadSubCommentsOfPage(n);
  };

  var handleSuccessPost = function handleSuccessPost(floor) {
    var SUBCOMMENTS_PAGE_SIZE = 10;
    closePostBox();
    var page = Math.ceil(floor / SUBCOMMENTS_PAGE_SIZE);
    loadSubCommentsOfPage(page);

    if (isShowMoreBtnVisible) {
      hideShowMoreBtn();
    }
  };

  var handleSubCommentDeleted = function handleSubCommentDeleted(commentId) {
    deleteSubComment(commentId);
  };

  var data = props.data;

  var totalComments = function totalComments() {
    return subComments.totalComments;
  };

  return /*#__PURE__*/React__default.createElement("div", _objectSpread({
    ref: containerRef,
    className: "comment-box"
  }, markTestId('comment')), /*#__PURE__*/React__default.createElement(CommentItem, {
    data: data,
    onReplyClick: handleClickReplyBtnToOP,
    onDeleteSuccess: handleReload
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "sub-content"
  }, enableReply && subComments.comments && subComments.comments.length > 0 && /*#__PURE__*/React__default.createElement(SubComments, {
    comments: subComments.comments,
    pagination: subComments.pagination,
    onSubCommentDeleted: handleSubCommentDeleted,
    onReplyClick: handleClickReplyBtnToSubComments,
    totalComments: totalComments(),
    onShowMore: handleShowMore,
    onChangePage: handlePageChange,
    isShowMoreBannerVisible: isShowMoreBtnVisible
  }), !props.small && isPostBoxVisible && /*#__PURE__*/React__default.createElement(CommentPostBox, {
    commentTargetData: {
      targetType: 'comment',
      comment_id: props.data.id,
      sub: postBoxOpenSource === POST_OPEN_SOURCE_FROM_OP ? 0 : 1
    },
    isReplyMode: true,
    onPostSuccess: handleSuccessPost,
    replyTo: userReplyTo
  })));
});

export { CommentBox };
